export const Months = [
    { lebel: 'January', value: 'January' },
    { lebel: 'February', value: 'February' },
    { lebel: 'March', value: 'March' },
    { lebel: 'April', value: 'April' },
    { lebel: 'May', value: 'May' },
    { lebel: 'June', value: 'June' },
    { lebel: 'July', value: 'July' },
    { lebel: 'August', value: 'August' },
    { lebel: 'September', value: 'September' },
    { lebel: 'October', value: 'October' },
    { lebel: 'November', value: 'November' },
    { lebel: 'December', value: 'December' },
]
export const companyType = [
    {
        value: 'Individual',
        label: 'Individual',
    },
    {
        value: 'Sole Proprietorship',
        label: 'Sole Proprietorship',
    },
    {
        value: 'Limited Liability Partnerships (LLP)',
        label: 'Limited Liability Partnerships (LLP)',
    },
    {
        value: 'Private Limited Companies',
        label: 'Private Limited Companies',
    },
    {
        value: 'One Person Companies (OPC)',
        label: 'One Person Companies (OPC)',
    },
    {
        value: 'Section 8 Companies',
        label: 'Section 8 Companies',
    },
    {
        value: 'Partnerships',
        label: 'Partnerships',
    },
    {
        value: 'Public Limited Companies',
        label: 'Public Limited Companies',
    },
    {
        value: 'Joint-Venture Companies',
        label: 'Joint-Venture Companies',
    },
    {
        value: 'Non-Government Organisations (NGOs)',
        label: 'Non-Government Organisations (NGOs)',
    },
]
export const accountType =[
    {
        value: 'Savings Account',
        label: 'Savings Account',
    },
    {
        value: 'Current Account',
        label: 'Current Account',
    },
    {
        value: 'Over Draft(OD)',
        label: 'Over Draft(OD)',
    },
    {
        value: 'Cash Credit(CC)',
        label: 'Cash Credit(CC)',
    },
]
export const bankNameList=[
    {
        value: 'Allahabad Bank',
        label: 'Allahabad Bank',
    },
    {
        value: 'Andhra Bank',
        label: 'Andhra Bank',
    },
    {
        value: 'AU Small Finance Bank',
        label: 'AU Small Finance Bank',
    },
    {
        value: 'Axis Bank',
        label: 'Axis Bank',
    },
    {
        value: 'Bandhan Bank',
        label: 'Bandhan Bank',
    },
    {
        value: 'Bank of Baroda',
        label: 'Bank of Baroda',
    },
    {
        value: 'Bank of India',
        label: 'Bank of India',
    },
    {
        value: 'Bank of Maharashtra',
        label: 'Bank of Maharashtra',
    },
    {
        value: 'Canara Bank',
        label: 'Canara Bank',
    },
    {
        value: 'Catholic Syrian Bank',
        label: 'Catholic Syrian Bank',
    },
]
export const getYears = () => {
    const currentYear = new Date().getFullYear();
    const year = [];
    for (let i = currentYear - 5; i <= currentYear; i++) {
        year.push({ lebel: i, value: i })
    }
    return year;
}